module.exports = __webpack_public_path__ + "static/media/wrl-njmp-logo@2x.7e08cecd.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/wrl-njmp-logo@2x.png
// module id = 1217
// module chunks = 0